import { Link } from "react-router-dom";

function MobileMenu({
    setMobileMenuShow,
    mobileMenuShow,
    setMobileMenuList,
    mobileMenuList
}) {
    return (
        <div className={`mobile-nav__wrapper ${mobileMenuShow ? 'expanded' : ''}`}>
            <div
                onClick={() => setMobileMenuShow(false)}
                className="mobile-nav__overlay mobile-nav__toggler"
            ></div>
            <div className="mobile-nav__content">
                <span
                    onClick={() => setMobileMenuShow(false)}
                    className="mobile-nav__close mobile-nav__toggler"
                >
                    <i className="icon-close"></i>
                </span>
                <div className="logo-box logo-retina">
                    <Link to="/" aria-label="logo image">
                        <img src="/assets/images/logo-light.png" width="209" alt="" />
                    </Link>
                </div>
                <div className="mobile-nav__container">
                    <ul className="main-menu__list one-page-scroll-menu">
                        <li className="scrollToLink current"><Link to="/">Bosh sahifa</Link></li>
                        <li className="scrollToLink"><Link to="/methods">Metodlar</Link></li>
                        <li className="scrollToLink"><Link to="/students">Talabalar uchun</Link></li>
                        <li className="scrollToLink"><Link to="/diagnostics">Kompetensiya diagnostikasi</Link></li>
                        <li className="scrollToLink"><Link to="/student-modules">O'quv ishlanmalari</Link></li>
                        <li className="scrollToLink"><Link to="/cases">Pedagogik keyslar</Link></li>
                        <li className="scrollToLink"><Link to="/challenge">Ijodiy topshiriq generatori</Link></li>
                        <li className="scrollToLink"><Link to="/reflection">Refleksiv kundalik</Link></li>
                        <li className="scrollToLink"><Link to="/recommender">Metod tavsiyachi</Link></li>
                        <li className="scrollToLink"><Link to="/compare">Metodlarni qiyoslash</Link></li>
                        <li className="scrollToLink"><Link to="/planner">Dars rejasi generatori</Link></li>
                        <li className="scrollToLink"><Link to="/quiz">Bilim testi va sertifikat</Link></li>
                        <li className="scrollToLink"><Link to="/map">Tajribalar xaritasi</Link></li>
                        <li className="dropdown megamenu scrollToLink ">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a
                                onClick={(e) => {
                                    e.preventDefault();
                                    setMobileMenuList(prev => !prev)
                                }}
                                href="#"
                            >
                                Tajribalar
                                <button
                                    aria-label="dropdown toggler"
                                ><i className="fa fa-angle-down"></i>
                                </button>
                            </a>
                            <ul style={{ display: `${mobileMenuList ? 'block' : 'none'}` }}>
                                <li>
                                    <section className="home-showcase">
                                        <div className="container">
                                            <div className="home-showcase__inner">
                                                <div className="row">
                                                    <div className="col-md-6 col-lg-3">
                                                        <div className="demo-one__card">
                                                            <div className="demo-one__image">
                                                                <img src="/assets/images/usa2_flag.jpg" className='img-fluid' alt="" />
                                                                <div className="demo-one__btns">
                                                                    <Link to="/experiment/usa"
                                                                        className="eduhive-btn demo-one__btn">
                                                                        <span>AQSH</span>
                                                                        <span className="eduhive-btn__icon">
                                                                            <span
                                                                                className="eduhive-btn__icon__inner"><i
                                                                                    className="icon-right-arrow"></i></span>
                                                                        </span>
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <div className="demo-one__content">
                                                                <h3 className="demo-one__title">
                                                                    <Link to="/experiment/usa">AQSH</Link>
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-3">
                                                        <div className="demo-one__card">
                                                            <div className="demo-one__image">
                                                                <img src="/assets/images/germany2_flag.jpg" className='img-fluid' alt="" />
                                                                <div className="demo-one__btns">
                                                                    <Link to="/experiment/germany"
                                                                        className="eduhive-btn demo-one__btn">
                                                                        <span>Germaniya</span>
                                                                        <span className="eduhive-btn__icon">
                                                                            <span
                                                                                className="eduhive-btn__icon__inner"><i
                                                                                    className="icon-right-arrow"></i></span>
                                                                        </span>
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <div className="demo-one__content">
                                                                <h3 className="demo-one__title">
                                                                    <Link to="/experiment/germany">Germaniya</Link>
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-3">
                                                        <div className="demo-one__card">
                                                            <div className="demo-one__image">
                                                                <img src="/assets/images/korea2_flag.jpg" className='img-fluid' alt="" />
                                                                <div className="demo-one__btns">
                                                                    <Link to="/experiment/korea"
                                                                        className="eduhive-btn demo-one__btn">
                                                                        <span>Janubiy Koreya</span>
                                                                        <span className="eduhive-btn__icon">
                                                                            <span
                                                                                className="eduhive-btn__icon__inner"><i
                                                                                    className="icon-right-arrow"></i></span>
                                                                        </span>
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <div className="demo-one__content">
                                                                <h3 className="demo-one__title">
                                                                    <Link to="/experiment/korea">Janubiy Koreya</Link>
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-lg-3">
                                                        <div className="demo-one__card">
                                                            <div className="demo-one__image">
                                                                <img src="/assets/images/russia2_flag.jpg" className='img-fluid' alt="" />
                                                                <div className="demo-one__btns">
                                                                    <Link to="/experiment/russia"
                                                                        className="eduhive-btn demo-one__btn">
                                                                        <span>Rossiya</span>
                                                                        <span className="eduhive-btn__icon">
                                                                            <span
                                                                                className="eduhive-btn__icon__inner"><i
                                                                                    className="icon-right-arrow"></i></span>
                                                                        </span>
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                            <div className="demo-one__content">
                                                                <h3 className="demo-one__title">
                                                                    <Link to="/experiment/russia">Rossiya</Link>
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <ul className="mobile-nav__contact list-unstyled">
                    <li>
                        <span className="mobile-nav__contact__icon"><i className="fa fa-envelope"></i></span>
                        <a href="mailto:info@rivojlan.uz">info@rivojlan.uz</a>
                    </li>
                    <li>
                        <span className="mobile-nav__contact__icon"><i className="fa fa-phone-alt"></i></span>
                        <a href="tel:+998933763383">+998933763383</a>
                    </li>
                </ul>
                <div className="mobile-nav__social social-links-two">
                    <a href="https://facebook.com">
                        <span className="social-links-two__icon">
                            <i className="fab fa-facebook-f" aria-hidden="true"></i>
                        </span>
                        <span className="sr-only">Facebook</span>
                    </a>
                    <a href="https://twitter.com">
                        <span className="social-links-two__icon">
                            <i className="fab fa-twitter" aria-hidden="true"></i>
                        </span>
                        <span className="sr-only">Twitter</span>
                    </a>
                    <a href="https://instagram.com">
                        <span className="social-links-two__icon">
                            <i className="fab fa-instagram" aria-hidden="true"></i>
                        </span>
                        <span className="sr-only">Instagram</span>
                    </a>
                    <a href="https://youtube.com">
                        <span className="social-links-two__icon">
                            <i className="fab fa-youtube" aria-hidden="true"></i>
                        </span>
                        <span className="sr-only">Youtube</span>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default MobileMenu